import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { AssetsReport } from "./AssetsDashboardComponents/AssetsReport";
import { AssetsTable } from "./AssetsDashboardComponents/AssetsTable";
import "./AssetsDashboard.css";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";

export const AssetsDashboard = () => {
  const history = useHistory();
  const reportRef = React.useRef(null);
  const [sharedState, setSharedState] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const updateSharedState = (newState) => {
    setSharedState(newState);
  };

  return (
    <div className="AssetsMain">
      <ModalVideo module="Assets" autoOpen={true} />
      <div className="assetscreate" style={{ display: "flex", gap: "10px" }}>
        <button
          className="addbuttonassets"
          onClick={() => {
            history.push("/asset_allocation");
          }}
        >
          {" "}
          + Add Asset
        </button>
        <button
          className="addbuttonassets"
          disabled={downloadLoading}
          style={{
            backgroundColor: "white",
            color: "#2a3da3",
            border: "1px solid #2a3da3",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: downloadLoading ? "not-allowed" : "pointer",
            opacity: downloadLoading ? 0.7 : 1,
            fontWeight: "600",
          }}
          onClick={() => {
            if (reportRef.current) {
              reportRef.current.downloadPDF();
            }
          }}
        >
          {downloadLoading ? (
            <LoadingOutlined style={{ fontSize: "20px" }} spin />
          ) : (
            <DownloadOutlined style={{ fontSize: "20px" }} />
          )}
          {downloadLoading ? "Downloading..." : "Download Report"}
        </button>
      </div>
      <div className="AssetsMainReport">
        <AssetsReport
          ref={reportRef}
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          onDownloadLoading={(loading) => setDownloadLoading(loading)}
        />
      </div>
      <div className="assetsTableCard">
        <AssetsTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
        />
      </div>
    </div>
  );
};
